import type { QuadriInCostruzione } from './costruzione'
import { arrotonda, dec, ZERO } from './dec'
import { bloccante, type Diagnostica } from './diagnostica'
import { mesiDelPeriodo, type DatiPeriodo } from './ingresso'
import type { RegolePeriodo } from './regole-periodo'
import { ripartisciScaglioni } from './scaglioni'

const QUADRI_CON_ACCISA = ['E', 'M'] as const

export function applicaScaglioni(q: QuadriInCostruzione, dati: DatiPeriodo, regole: RegolePeriodo): void {
  const s = regole.scaglioni
  if (s === undefined) return
  const soggette = new Set(s.tipologieSoggette)
  const quadroM = dati.formulePersonalizzate.quadroM
  const mesi = mesiDelPeriodo(dati.periodo, dati.annoImposta).mesi

  for (const quadro of QUADRI_CON_ACCISA) {
    const righe = q[quadro]
    if (righe === undefined) continue
    const altre = righe.filter((r) => !soggette.has(String(r.tipologia)))
    const ripartite = mesi.flatMap(({ mese }) => {
      const delMese = righe.filter((r) => soggette.has(String(r.tipologia)) && r.mese === mese)
      if (delMese.length === 0) return []
      const utenze =
        s.moltiplicaPerUtenze && quadroM?.usiCommerciali !== false ? Number(delMese[0]!.numeroUtenze ?? 1) : 1
      return ripartisciScaglioni(delMese, s, utenze)
    })
    q[quadro] = [...altre, ...ripartite]
  }

  // Il progressivo del quadro M e' il numero del rigo: M4 -> 4.
  for (const r of q.M ?? []) r.progr ??= Number(String(r.tipologia).slice(1))
}

export function applicaAccisa(q: QuadriInCostruzione, regole: RegolePeriodo): Diagnostica[] {
  const diagnostiche: Diagnostica[] = []
  const fissiApplicati = new Set<string>()

  for (const quadro of QUADRI_CON_ACCISA) {
    for (const r of q[quadro] ?? []) {
      const rigo = String(r.tipologia)
      const aliquota = regole.aliquote[rigo]
      if (aliquota === undefined) {
        const posizione = r.mese === undefined ? { quadro } : { quadro, mese: Number(r.mese) }
        diagnostiche.push(bloccante('ALIQUOTA_SCONOSCIUTA', `nessuna aliquota per il rigo ${rigo}`, posizione))
        continue
      }
      if ('fissoMensile' in aliquota) {
        // Una sola volta per mese e ambito, non per quadro: il riferimento
        // (`energix-comportamento-semestrale.md`, M7) dice «4.820 EUR fissi, una sola
        // volta per mese» senza qualificare per quadro. Con la chiave per quadro un
        // impianto che supera la soglia alta sia in E sia in M pagherebbe il doppio.
        const chiave = `${String(r.ambito)}|${String(r.mese)}|${rigo}`
        r.aliquota = ZERO
        r.accisa = fissiApplicati.has(chiave) ? ZERO : aliquota.fissoMensile
        fissiApplicati.add(chiave)
      } else {
        r.aliquota = aliquota
        r.accisa = arrotonda(dec(r.kwh ?? 0).times(aliquota), regole.arrotondamento.importi)
      }
    }
  }
  return diagnostiche
}
